export enum ELinkType {
  LINK_TO = 'link-to',
  BE_LINKED = 'be-linked',
}

export const enum ESmartBarcodeType {
  MOBILE = 'mobile',
  PORTAL = 'portal',
}

export const enum ELanguageLocale {
  EN = 'en',
  JA = 'ja',
  ZH = 'zh',
  ZHTW = 'zh-tw',
  ZHCN = 'zh-cn',
}

export const enum EAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  CANCEL = 'cancel',
}

export const enum EGraphType {
  BARCHART = 'BarChart',
  COLCHART = 'ColumnChart',
  PIECHART = 'PieChart',
  LINECHART = 'LineChart',
}

export const enum EGraphOption {
  CLUSTERED = 'Clustered',
  STACKED = 'Stacked',
  STACKED_PERCENT = 'StackedPercent',
}

export const enum EDateType {
  YEAR = 'Year',
  QUARTER = 'Quarter',
  MONTH = 'Month',
  WEEK = 'Week',
  DAY = 'Day',
  UNKNOWN = 'Unknown',
}

export const enum EGraphFunction {
  SUM = 'Sum',
  COUNT = 'Count',
  AVERAGE = 'Average',
}

export const enum ESortType {
  ASC = 'asc',
  DES = 'desc',
}

export const enum ESmartBarcodeMenu {
  DASHBOARD = 'dashboard',
  TIMETABLE = 'timetable',
  PROJECT = 'projects',
  CLIENT = 'clients',
  LOCATION = 'location',
  CARRIER = 'carriers',
  ADDRESS_BOOK = 'address-book',
  PRODUCT = 'product',
  MARUMIYA_PRODUCTS = 'marumiya-products',
  SUPPLIERS = 'suppliers',
  WORK_CENTERS = 'work-centers',
  WAREHOUSES = 'warehouses',
  MANUFACTURING_PLAN = 'manufacturing-plan',
  CONVERSION_FACTORS = 'conversion-factors',
  SERIAL = 'serial',
  ENTERPRISE = 'enterprise',
  PERMISSION = 'permission',
  BARCODE_SEARCH = 'barcodeSearch',
  BARCODE_PROCESS = 'barcodeProcess',
  BARCODE_PUBLISH = 'barcodePublish',
}

export const enum EBarcodePublishStatus {
  COMPLETED = 'completed',
  ERROR = 'error',
  REQUESTED = 'requested',
  PROGRESS = 'processing',
}

export enum EUserRole {
  OWNER = 'owner',
  EDITOR = 'editor',
  VIEWER = 'viewer',
}

export enum EDimensionKey {
  WIDTH = 'width',
  HEIGHT = 'height',
  DEPTH = 'depth',
  WEIGHT = 'weight',
}

export enum EEventType {
  ACTIVATING = 'activating',
  TRACKING = 'tracking',
}

export enum ENotificationtiming {
  BEFORE = 'before',
  AFTER = 'after',
  AT_THE_TIME = 'atTheTime',
}

export enum ECustomFieldExtraType {
  TEXT_AREA = 'textarea',
}

export const enum ERestrictionOption {
  MANDATORY = 'mandatory',
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
}

export enum EDisplayRestrictionOption {
  MANDATORY = 'mandatory',
  OPTIONAL = 'optional',
  HIDDEN = 'hidden',
}

export enum EEncodingType {
  UTF_8 = 'utf8',
  SHIFT_JIS = 'shiftJIS',
  BIG_5 = 'big5',
  GB_2312 = 'gB2312',
  UNKNOWN = 'unknown',
  EMPTY = '',
}

export enum ERouteWidth {
  SHORT = 'short',
  MEDIUM = 'medium',
  LONG = 'long',
}

export enum ELinkedBarcodeHrefType {
  SNAPSHOT = 'snapshot',
  LATEST = 'latest',
}

export const enum EGroupField {
  PROJECT_CODE = 'projectCode',
  BARCODE_TYPE = 'barcodeType',
  CURRENT_TRACKPOINT_KEY = 'currentTrackPointKey',
}

export enum EOCRReaderType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
}

export enum EReaderType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
  SCANDIT = 'scandit',
}

export const enum ETimeTableDirection {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}

export const enum EPathType {
  DEPARTURE = 'departure',
  ARRIVAL = 'arrival',
}

export const enum ETimeTableState {
  SCHEDULED = 'scheduled',
  TRACKED = 'tracked',
  DELAYED = 'delayed',
  ACKED = 'acked',
  NONE = 'none',
}

export const enum ELocationItemFunction {
  COUNT = 'count',
  SUM = 'sum',
}

export const enum EExportType {
  BARCODE = 'barcode',
  MASTER_DATA = 'masterData',
  ACCESS_LOG = 'accessLog',
  LOCATION = 'location',
  ARCHIVE = 'archive',
  FILE = 'files',
  BULK_REPORT_MO = 'bulkReportMO',
  // SUPPLIER = 'supplier',
  // WORKCENTER = 'workcenter',
  // WAREHOUSE = 'warehouse',
  // MARUMIYA_PRODUCT = 'marumiyaProduct',
}

export const enum EProcessID {
  SEND_PO = 'COPO',
  ISSUE_CONTRACT = 'COCOS',
  STORE_LETTER_OF_CREDIT = 'LCACCEPT',
  REQUEST_BOOKING_TPA = 'TPARB',
  EXPORT_SHIPPING_INSTRUCTION_1 = 'ECREQ01',
  EXPORT_SHIPPING_INSTRUCTION_2 = 'ECREQ02',
  EXPORT_SHIPPING_INSTRUCTION_3 = 'ECREQ03',
  EXPORT_SHIPPING_INSTRUCTION_4 = 'ECREQ04',
  EXPORT_SHIPPING_INSTRUCTION_5 = 'ECREQ05',
  STORE_EXPORT_CUSTOM_PERMIT = 'ECPERMIT',
  REQUEST_INSURANCE_POLICY_1 = 'MIRIP01',
  REQUEST_INSURANCE_POLICY_2 = 'MIRIP02',
  REQUEST_INSURANCE_POLICY_3 = 'MIRIP03',
  STORE_INSURANCE_POLICY = 'MIIP',
  REQUEST_BOOKING_TP = 'TPRB',
  REQUEST_BILL_OF_LADING = 'TPRBL',
  BILL_OF_LADING_INFORMATION_1 = 'TPBLI01',
  BILL_OF_LADING_INFORMATION_2 = 'TPBLI02',
  STORE_BILL_OF_LADING = 'TPBL',
  CREATE_SHIPPING_DOCUMENTS = 'FDCRTDOC',
  SEND_SHIPPING_DOCUMENTS = 'FDDOC',
  IMPORT_INSTRUCTION_1 = 'ICREQ01',
  IMPORT_INSTRUCTION_2 = 'ICREQ02',
  IMPORT_INSTRUCTION_3 = 'ICREQ03',
  IMPORT_INSTRUCTION_4 = 'ICREQ04',
  IMPORT_INSTRUCTION_5 = 'ICREQ05',
  STORE_IMPORT_CUSTOMS_PERMIT = 'ICPERMIT',
  REQUEST_CERTIFICATE_OF_ORIGIN_1 = 'FDCOR01',
  REQUEST_CERTIFICATE_OF_ORIGIN_2 = 'FDCOR02',
  REQUEST_CERTIFICATE_OF_ORIGIN_3 = 'FDCOR03',
  REQUEST_CERTIFICATE_OF_ORIGIN_4 = 'FDCOR04',
  REQUEST_CERTIFICATE_OF_ORIGIN_5 = 'FDCOR05',
}
export const enum EProgressStatus {
  NOT_STARTED = 0,
  INPUT_IN_PROGRESS_FROM = 1,
  AWAITING_APPROVAL_FROM = 2,
  AWAITING_CONFIRMATION_TO = 3,
  INPUT_IN_PROGRESS_TO = 4,
  AWAITING_APPROVAL_TO = 5,
  AGRREED = 6,
  DONE = 7,
  INPUT_IN_PROGRESS = 8,
}

export const enum EEntityStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  CLOSED = 9,
}

export const enum EProcessType {
  COPO = 'PT_COPO',
  COCOS = 'PT_COCOS',
  ECREQ = 'PT_ECREQ',
  ECPERMIT = 'PT_ECPERMIT',
  MIIP = 'PT_MIIP',
  TPBL = 'PT_TPBL',
  FDDOC = 'PT_FDDOC',
  ICREQ = 'PT_ICREQ',
  FDCRTDOC = 'PT_FDCRTDOC',
  ICPERMIT = 'PT_ICPERMIT',
  LCACCEPT = 'PT_LCACCEPT',
  TPATPRB = 'PT_TPATPRB',
  TPRBL = 'PT_TPRBL',
  TPBLI = 'PT_TPBLI',
  FDCOR = 'PT_FDCOR',
  FDCOI = 'PT_FDCOI',
  MIRIP = 'PT_MIRIP',
}

export enum EBCRType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
  SCANDIT = 'scandit',
  BARCODE_DETECTION = 'barcodeDetector',
}

export enum EOCRType {
  UNKNOWN = 'unknown',
  DEFAULT = 'default',
}

export enum ECameraReaderType {
  OCR = 'ocr',
  BCR = 'barcode_reader',
}

export const enum EBCTypeIconKey {
  NODE = 'node',
  LEAF = 'leaf',
  ORPHAN = 'orphan',
  VACCINE = 'vaccine',
  TRUCK = 'truck',
  CONTAINER = 'container',
  TIMETABLE = 'timetable',
  INVENTORY = 'inventory',
  WAREHOUSE = 'warehouse',
  RACK = 'rack',
  FORKLIFT = 'forklift',
  PACKAGES = 'packages',
  PACKAGE = 'package',
  PAPER = 'paper',
  PERSON = 'person',
  TRAIN = 'train',
  SHIP = 'ship',
  AIRPLANE = 'airplane',
}

export const enum EPackageInfoKey {
  TRACKING_NUMBER = 'trackingNumber',
  EXTERNAL_ID = 'externalId',
  DIMENSION = 'dimension',
  WIDTH = 'width',
  WEIGHT = 'weight',
  HEIGHT = 'height',
  DEPTH = 'depth',
}

// Barcode reader catetory
export const enum EBCReaderCategory {
  QR = 'QR',
  ONE_DIMENSION = '1D',
  DEFAULT = 'Default',
}

export const enum EStockOperationType {
  INSTOCK = 'inStock',
  OUTSTOCK = 'outStock',
}

export enum BarcodeExportType {
  BULK_REPORT_OUTPUT = 'bulkReportOutput',
  REPORT_OUTPUT = 'reportOutput',
}
